export default __webpack_public_path__ + "media/images/affaire-new-16b6b708cd8b657cba7dba09a461d279.png";